import { useQuery } from '@tanstack/react-query';

const getComponentEntryQueryKey = entryKey => ["component-framework/get-component-entry", entryKey];
const getComponentEntryQuery = entryKey => {
  return {
    queryKey: getComponentEntryQueryKey(entryKey),
    // Fetching of component entries will be handled in another layer.
    // See individual clients for
    queryFn: () => undefined,
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
    meta: {
      persist: false
    }
  };
};
const useComponentEntry = (entryKey, extraConfig) => {
  return useQuery({
    ...getComponentEntryQuery(entryKey),
    ...extraConfig
  });
};

export { getComponentEntryQuery, getComponentEntryQueryKey, useComponentEntry };
//# sourceMappingURL=query.get.js.map
